<template>
  <div>
    <top-header :type="6" placeholder="同房源其他挂牌" fontSize="0.32rem" />
    <div class="record_list">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="no_data" v-if="!list.length">
          <img src="@/assets/img/nodata.png" alt="" />
        </div>
        <div
          class="row m_flex_box flex_vc flex_jz"
          v-for="(item, index) in list"
          :key="index"
          @click="jumpDetail(item.id)"
        >
          <div class="left m_flex_box flex_vc" style="flex:1;display:flex">
            <img v-lazy="imgPath + 'sClf/' + item.img + '.jpg'" alt="" />
            <div class="priceLocation">
              <h5>{{ item.businessId?item.businessName:(item.createName ? item.createName : "-") }}</h5>
              <p>
                {{ item.businessId?'商业网站挂牌':(item.listedType == 0 ? "个人核验挂牌" : "经纪人核验挂牌") }}
              </p>
              <span
                style="margin-left: 0.16rem; color: #f92d2d; font-weight: bold"
                >{{ Math.round(item.listedPrice / 10000) }}万元</span
              >
            </div>
          </div>
          <div class="right m_flex_box" v-if="!item.businessId">
            <a @click.stop="callTo(item.phoneNum, 1, item.listedUserId)">
              <img src="@/assets/img/r_tel.png" alt="" />
            </a>
            <img
              src="@/assets/img/r_chat.png"
              alt=""
              @click.stop="toTalk(item.id)"
            />
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";
export default {
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      list: [],
      houseListedId: this.$route.query.houseListedId,
      mainId: this.$route.query.mainId,
      currPageNo: 1,
      timer: null,
    };
  },
  components: {
    topHeader,
  },
  filters: {
    formatTime: function (dates, fmt) {
      var date = new Date(dates);
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      var o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
      };
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          var str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
          );
        }
      }
      return fmt;
    },
  },
  mounted() {},
  methods: {
    toTalk(id) {
      this.$router.push({
        path: "/chat",
        query: {
          id,
        },
      });
    },
    jumpDetail(id) {
      this.$router.push({
        path: "/houseDetail",
        query: {
          mainId: this.mainId,
          houseListedId: id,
        },
      });
    },
    callTo(phone, lx, infoId) {
      this.$http.post("cms/onlineUser/reg/isLogin.do").then((res) => {
        if (res.success) {
          this.$new
            .post(
              "telTj/addTeltj.do",
              qs.stringify({
                phone,
                lx,
                infoId,
              })
            )
            .then((res) => {
              window.location.href = `tel:${phone}`;
            });
        } else {
          this.$toast(res.msg);
        }
      });
      // if(!phone) {
      //   this.$dialog.alert({
      //     title: '提示',
      //     message: '暂无可拨打电话'
      //   });
      //   return;
      // }
      // this.$new.post('telTj/addTeltj.do', qs.stringify({
      //   phone,
      //   lx,
      //   infoId
      // })).then(res => {
      //   window.location.href = `tel:${phone}`
      // })
    },
    onRefresh() {
      this.loading = false;
      this.finished = false;
      this.$set(this.formData, "currPageNo", 1);
      this.$set(this, "list", []);
      this.onLoad(1);
    },
    onLoad(type) {
      // if (!this.timer) {
      //   this.timer = setTimeout(() => {
      //     this.timer = null;
      //   }, 50)
      var item = qs.stringify({
        mainId: this.mainId,
        houseListedId: this.houseListedId,
      });
      this.$http({
        url: "cms/houseListed/permit/getOtherListedDetail.do",
        method: "POST",
        // headers: {
        //   'Content-Type': 'application/x-www-form-urlencode'
        // },
        data: item,
      }).then((res) => {
        if (res.success) {
          this.list = res.obj;
          this.loading = false;
          this.finished = true;
          // this.$set(this, 'currPageNo', this.currPageNo + 1);
        } else {
          this.finished = true;
        }
      });
      // }
    },
  },
};
</script>
<style lang="less" scoped>
.pad_top {
  padding-top: 0.9rem;
}
.record_list {
  width: 7.04rem;
  margin: 0 auto;
  .row {
    padding: 0.2rem 0;
    &:last-child {
      padding-bottom: 0;
    }
    .left {
      img {
        width: 0.78rem;
        height: 0.78rem;
        border-radius: 50%;
        margin-right: 0.16rem;
      }
      h5 {
        font-size: 0.28rem;
      }
      p {
        font-size: 0.22rem;
        color: #a0a0a0;
      }
      .priceLocation {
        flex:1;
        position: relative;
        span {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
    .right {
      img {
        width: 0.62rem;
        height: 0.62rem;
        margin-left: 0.52rem;
      }
      a {
        img {
          margin-left: 0;
        }
      }
    }
  }
}
</style>